module.exports = __webpack_public_path__ + "img/base_text.95d2e91e.svg";